import { render, staticRenderFns } from "./StartVirtualMachine.vue?vue&type=template&id=65fb095a&scoped=true&"
import script from "./StartVirtualMachine.vue?vue&type=script&lang=js&"
export * from "./StartVirtualMachine.vue?vue&type=script&lang=js&"
import style0 from "./StartVirtualMachine.vue?vue&type=style&index=0&id=65fb095a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fb095a",
  null
  
)

export default component.exports